<template>
  <div class="theme-container"
       :class="pageClasses"
       @touchstart="onTouchStart"
       @touchend="onTouchEnd">
    <Navbar v-if="shouldShowNavbar"
            :auth="auth"
            :authenticated="authenticated"
            @toggle-sidebar="toggleSidebar"/>
    <div class="sidebar-mask" @click="toggleSidebar(false)"></div>

    <Sidebar
      :auth="auth"
      :authenticated="authenticated"
      :items="sidebarItems"
      @toggle-sidebar="toggleSidebar">
      <slot name="sidebar-top" slot="top"/>
      <slot name="sidebar-bottom" slot="bottom"/>
    </Sidebar>

    <div class="content-container">
      <GenerateToken v-if="this.authenticated && this.$route.hash === '#generate-token'"
        :auth="auth"
        :authenticated="authenticated"/>
      <ManageClient v-else-if="this.authenticated && this.$route.hash === '#api-clients'"
        :auth="auth"
        :authenticated="authenticated"/>
      <Home v-else-if="this.$route.name === 'home'"
        :auth="auth"
        :authenticated="authenticated"
        :error="error"/>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import nprogress from "nprogress";
import Home from "./Home.vue";
import GenerateToken from "./GenerateToken.vue";
import ManageClient from "./ManageClient.vue";
import Navbar from "./Navbar.vue";
import Sidebar from "./Sidebar.vue";

export default {
  props: ["auth", "authenticated", "error"],
  components: { Home, Sidebar, Navbar, GenerateToken, ManageClient },
  data() {
    return {
      isSidebarOpen: false
    };
  },
  computed: {
    shouldShowNavbar() {
      return true;
    },
    shouldShowSidebar() {
      return (
        this.$route.hash === "#api-clients" ||
        this.$route.hash === "#generate-token"
      );
    },
    sidebarItems() {
      if (!this.authenticated) {
        return [];
      }
      return [
        {
          title: "API Clients",
          path: "/#api-clients",
          type: "page"
        },
        {
          title: "Generate Token",
          path: "/#generate-token",
          type: "page"
        }
      ];
    },
    pageClasses() {
      return [
        {
          "no-navbar": !this.shouldShowNavbar,
          "sidebar-open": this.isSidebarOpen,
          "no-sidebar": !this.shouldShowSidebar
        }
      ];
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    // configure progress bar
    nprogress.configure({ showSpinner: false });
    this.$router.beforeEach((to, from, next) => {
      if (to.path !== from.path && !Vue.component(to.name)) {
        nprogress.start();
      }
      next();
    });
    this.$router.afterEach(() => {
      nprogress.done();
      this.isSidebarOpen = false;
    });
  },
  methods: {
    toggleSidebar(to) {
      this.isSidebarOpen = typeof to === "boolean" ? to : !this.isSidebarOpen;
    },
    // side swipe
    onTouchStart(e) {
      this.touchStart = {
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY
      };
    },
    onTouchEnd(e) {
      const dx = e.changedTouches[0].clientX - this.touchStart.x;
      const dy = e.changedTouches[0].clientY - this.touchStart.y;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        if (dx > 0 && this.touchStart.x <= 80) {
          this.toggleSidebar(true);
        } else {
          this.toggleSidebar(false);
        }
      }
    }
  }
};
</script>

<style src="prismjs/themes/prism-solarizedlight.css">
</style>
<style src="./styles/theme.styl" lang="stylus"></style>
